<template>
  <section id="relic-detail-report">
    <edit-header
      title="巡查报告"
      :visible-action="false"
      :visible-add="true"
      add-text="添加巡查记录"
      @onAddClick="handleAddReport"
      :addLimit="limitReportAdd"
    ></edit-header>
    <img
      v-if="limitReportAdd || limitShow"
      class="report-delete"
      :src="deleteList[0] ? deletePic.normal_delete : deletePic.disabled_delete"
      alt="删除"
      @click="handleDeleteClick"
    />
    <table-vue
      :columns="reportDetailTable"
      :tableData="reportList"
      @onSelectItem="handleDeleteReports"
      @onRowClick="handleEditClick"
    />
    <div class="font-label report-tip">
      显示最新十条巡查记录，更多可前往
      <router-link class="report-tip-link" :to="{ name: 'Report' }">
        【巡查报告】
      </router-link>
      进行查看
    </div>
    <report-found
      v-model="saveCtrlParam"
      v-bind:reportDetail.sync="reportDetail"
      @onSaveAllClick="handleSaveReport"
      @onCancelEdit="initReportDetail"
      @onSavePart="handleSavePartReport"
    />
    <confirm-delete-popup
      v-if="visiblePopup"
      @onConfirmDelete="handleConfirmDelete"
      @onCancelDelete="visiblePopup = false"
    />
    <file-uploader-ctrl-vue ref="uploader" :filePath="filePath" />
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import {
  searchNewestInspectreport,
  addInspectreport,
  updateReportPhotoList,
  getReportDetail,
  getReportPhoto,
  updateReport
} from '../../api';
import { roleJudge } from '../../config/roleJudge';
import ConfirmDeletePopup from '../layout/confirm-delete-popup.vue';
import editHeader from '../layout/edit-header.vue';
import fileUploaderCtrlVue from '../layout/file-uploader-ctrl.vue';
import tableVue from '../layout/table.vue';
import { reportDetailTable } from '../report/report-detail-table.js';
import ReportFound from '../report/report-found.vue';
export default {
  components: {
    fileUploaderCtrlVue,
    editHeader,
    tableVue,
    ReportFound,
    ConfirmDeletePopup
  },
  props: {
    reportList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visiblePopup: false,
      reportDetailTable,
      reportDetail: {},
      reportData: [],
      deleteList: [],
      deletePic: {
        normal_delete: require('../../assets/images/normal_delete.svg'),
        disabled_delete: require('../../assets/images/disabled_delete.svg')
      },
      // visibleAdd: false,
      saveCtrlParam: {
        visibleAddDialog: false, //是否显示弹窗
        active: 0, //控制组件活动
        visibleEdit: false, //是否可编辑
        visibleCreate: false //是否是创建模式
      }
    };
  },

  computed: {
    ...mapState('login', ['userInfo', 'authorizationLimit', 'limitShow']),
    ...mapState('relic', ['relicDetail']),
    rerlicId() {
      return this.$route.params.id;
    },
    limitReportAdd() {
      return roleJudge(this.authorizationLimit, 4);
    },
    filePath() {
      return `relic/${this.relicDetail.relicAutoIncrementId}/report`;
    }
  },

  watch: {
    saveCtrlParam: {
      deep: true,
      handler(newValue) {
        if (!newValue.visibleAddDialog) {
          this.$emit('onRefreshReport');
        }
      }
    }
  },
  methods: {
    handleDeleteClick() {
      if (this.deleteList.length > 0) {
        this.visiblePopup = true;
      }
    },
    /**
     * 监听保存按钮回调
     */
    async handleSaveReport() {
      this.saveCtrlParam.visibleCreate
        ? await this.handleConfirmAddReport()
        : await this.handleSavePartReport();
      this.saveCtrlParam.visibleAddDialog = false;
      this.saveCtrlParam.active = 0;
    },
    /**
     * 添加巡查报告回调
     */
    async handleAddReport() {
      //
      const {
        data: { data }
      } = await searchNewestInspectreport(this.rerlicId);
      let { relicAddress } = this.relicDetail;

      if (data) {
        this.reportDetail = Object.assign({}, data, {
          inspectorNickName: this.userInfo.nickName,
          inspectorUid: this.userInfo.uid,
          photos: [],
          createTime: '--',
          updateTime: '--',
          inspectMessage: '',
          relicAddress
        });
      } else {
        const reportTemplate = {
          agent: '',
          agentContact: '',
          brandStatusEnum: '',
          buildingDamageStatusEnum: '',
          constructingComponentEnums: [],
          createTime: '--',
          facadeStatusEnum: '',
          finished: '',
          inspectMessage: '',
          inspectReportId: '',
          inspectStatusEnum: '',
          inspectTypeEnum: '',
          inspectorNickName: '',
          inspectorUid: '',
          otherConstructingComponents: '',
          otherSituationEnums: [],
          owner: '',
          ownerContact: '',
          relicAddress,
          relicAutoIncrementId: this.relicDetail.relicAutoIncrementId,
          relicDirectorEnum: '',
          relicDistrictEnum: '',
          relicFromUserId: '',
          relicName: '',
          updateTime: '--',
          user: '',
          userContact: ''
        };
        this.reportDetail = Object.assign({}, reportTemplate, {
          inspectorNickName: this.userInfo.nickName,
          inspectorUid: this.userInfo.uid,
          photos: []
        });
      }
      this.saveCtrlParam.visibleEdit = true;
      this.saveCtrlParam.visibleAddDialog = true;
      this.saveCtrlParam.visibleCreate = true;
    },

    /**
     * 点击表格编辑回调
     */
    async handleEditClick(row) {
      const { inspectReportId } = row;
      this.inspectReportId = inspectReportId;
      await this.initReportDetail(inspectReportId);
      this.saveCtrlParam.visibleEdit = false;
      this.saveCtrlParam.visibleAddDialog = true;
      this.saveCtrlParam.visibleCreate = this.checkedEditAble();
      // this.visibleAdd = true;
      //
      // this.visibleAdd = true;
    },

    /**
     * 巡查报告只能由巡查报告创建者与数据维护员，管理员进行编辑
     */
    checkedEditAble() {
      const editLimit = roleJudge(this.authorizationLimit, 1, 2);
      if (editLimit) return !editLimit;
      const visibleInspector =
        this.userInfo.uid === this.reportDetail.inspectorUid;
      return !visibleInspector;
    },

    /**
     * 获取单个报告的信息
     */
    async initReportDetail(id = this.inspectReportId) {
      const {
        data: { data: detail }
      } = await getReportDetail(id);
      console.log(detail);
      detail.createTime = this.formatDateTime(detail.createTime);
      detail.updateTime = this.formatDateTime(detail.updateTime);
      const {
        data: { data: photo }
      } = await getReportPhoto(id);
      this.reportDetail = Object.assign({}, detail, { photos: photo });
    },

    /**
     * 确认删除报告
     */
    handleConfirmDelete() {
      this.visiblePopup = false;
      this.$emit('onDeleteReport', this.deleteList);
    },

    /**
     * 监听选中删除的建筑回调
     */
    handleDeleteReports(itemList) {
      //
      this.deleteList = itemList;
    },

    /**
     * 确认添加巡查报告
     */
    async handleConfirmAddReport() {
      const baseInfo = Object.assign({}, this.reportDetail);
      const imglist = this.reportDetail.photos;
      delete baseInfo.photos;
      const {
        data: { data: inspectReportId }
      } = await addInspectreport(baseInfo);
      //
      const photoUpdateQueryList = await this.handleUploadPhoto(imglist);
      if (photoUpdateQueryList.length > 0)
        await updateReportPhotoList({ photoUpdateQueryList, inspectReportId });
      this.visibleAdd = false;
      // this.saveCtrlParam.visibleAddDialog = false;
      this.$prompt('创建成功');
      this.saveCtrlParam.visibleAddDialog = false;
    },

    /**
     * 上传照片回调
     * @param {Array} params 照片数组
     */
    async handleUploadPhoto(params) {
      let oldArray = params.filter(item => !item.file);
      let newArray = params.filter(item => item.file);
      if (newArray.length > 0) {
        const result = await this.$refs.uploader.uploadFileParams(newArray);

        newArray = result.map(item => {
          const {
            value: { param, url }
          } = item;
          delete param.file;
          param.url = url;
          param.thumb = url;
          return param;
        });
      }
      return [...oldArray, ...newArray];
    },

    /**
     * 编辑状态弹窗保存修改已有巡查报告回调
     */
    async handleSavePartReport() {
      //
      // this.reportDetail.userUid=this.userInfo.uid
      const data = Object.assign({}, this.reportDetail, {
        userUid: this.userInfo.uid
      });
      const { photos, inspectReportId } = this.reportDetail;
      delete data.photos;
      //
      //
      await updateReport(data);
      const photoUpdateQueryList = await this.handleUploadPhoto(photos);
      // if (photoUpdateQueryList.length > 0)
      //
      await updateReportPhotoList({ photoUpdateQueryList, inspectReportId });
      // this.saveCtrlParam.visibleAddDialog = false;
      this.$prompt('保存成功');
    }
  }
};
</script>

<style lang="scss" scoped>
#relic-detail-report {
  padding-bottom: 20px;
  .report {
    &-delete {
      margin-top: 10px;
      margin-left: 20px;
    }
    &-tip {
      padding: 10px 0px;
      &-link {
        color: $color-primary;
      }
    }
  }
}
</style>
